export function orderMenuPosition(anchor: { left: number; right: number; top: number; bottom: number }, viewport: { left: number; top: number; width: number; height: number }, height: number, rtl: boolean) {
  const padding = 12;
  const width = Math.min(280, Math.max(44, viewport.width - padding * 2));
  const maxHeight = Math.max(44, Math.min(480, viewport.height - 100));
  const menuHeight = Math.min(height || maxHeight, maxHeight);
  const minTop = viewport.top + padding;
  const maxBottom = viewport.top + viewport.height - 88;
  const below = anchor.bottom + 6;
  const top = Math.max(minTop, Math.min(below + menuHeight <= maxBottom ? below : anchor.top - menuHeight - 6, maxBottom - menuHeight));
  const left = Math.max(viewport.left + padding, Math.min(rtl ? anchor.left : anchor.right - width, viewport.left + viewport.width - width - padding));
  return { left, top, width, maxHeight };
}
